/**
 * @see https://confluence.wargaming.net/pages/viewpage.action?spaceKey=WGCGK&title=Web+to+client+API
 * @see https://confluence.wargaming.net/display/WEBDEV/CMT+improvements
 */

import { defineMessages } from 'react-intl'
import { formatMessage } from 'locale'

import { userContextMenu as webToClientUserContextMenu } from 'helpers/web_to_client'

import { canManage, hasPermission, permissions } from 'utils/clan_management/roles'

const localizedActionNames = defineMessages({
    divide_profits: {
        id: 'clanmanagement.context_menu.divide_profits',
        defaultMessage: 'Распределить казну',
    },
    change_role: {
        id: 'clanmanagement.context_menu.change_role',
        defaultMessage: 'Изменить должность',
    },
    change_commander: {
        id: 'clanmanagement.context_menu.change_commander',
        defaultMessage: 'Передать командование',
    },
    remove_member: {
        id: 'clanmanagement.context_menu.remove_member',
        defaultMessage: 'Исключить из клана',
    },
})

/**
 * customItems array format:
 * [customItemId, customItemLocalizedString, isEnabled]
 */
export const userContextMenu = (memberId) => {
    return (dispatch, getState) => {
        const state = getState()

        const member = state.members.members.find(member => member.id === memberId)
        if (member.isAnonymized) return

        const author = state.members.members.find(member => member.id === state.account.id)
        const canManageMember = canManage(author.role, member.role)

        let customItems = []

        if (hasPermission(author.role, permissions.DIVIDE_PROFITS)) {
            const message = formatMessage(localizedActionNames.divide_profits)
            const enabled = (
                Object.values(state.clan.treasury).some(amount => amount !== 0) &&
                !member.isSuspended
            )

            customItems.push(
                ['DIVIDE_PROFITS', message, enabled]
            )
        }
        if (hasPermission(author.role, permissions.CHANGE_COMMANDER)) {
            const message = formatMessage(localizedActionNames.change_commander)
            const enabled = canManageMember && !member.isSuspended

            customItems.push(
                ['CHANGE_COMMANDER', message, enabled]
            )
        }
        if (hasPermission(author.role, permissions.CHANGE_ROLE)) {
            const message = formatMessage(localizedActionNames.change_role)
            const enabled = canManageMember

            customItems.push(
                ['CHANGE_ROLE', message, enabled]
            )
        }

        if (hasPermission(author.role, permissions.REMOVE_MEMBER)) {
            const message = formatMessage(localizedActionNames.remove_member)
            const enabled = canManageMember

            customItems.push(
                ['REMOVE_MEMBER', message, enabled]
            )
        }

        return webToClientUserContextMenu(memberId, member.name, customItems)
            .then(action => ({ member, action }))
    }
}



// WEBPACK FOOTER //
// ./state/actions/CMT/ContextMenu.js